import easydropdown from 'easydropdown';


function fireNewsroom() {

    if ($('.js-newsroom-search select.dropdown').length) {
        const edd = easydropdown.all();
    }

    // fireForms();

    var speed = 500;
    var shown = 0;
    var startCount = $('.js-show-item').not('.js-hidden-item').length;
    var totalCount = $('.js-show-item').length;

    function setCounts() {
        $('.js-active-item-count').text(startCount);
        $('.js-active-item-total').text(totalCount);
        $('.js-counter-set.js-active').text(totalCount);
    }

    setCounts();

    if(startCount === totalCount) {
        $('.js-show-more-items').hide()
    } else {
        $('.js-show-more-items').on('click', function(e) {
            if (!$(this).hasClass('js-active')) {
                return false;
            }
            e.preventDefault();
            var counter =  parseInt($('.js-counter-set.js-active').text());


            var count = shown;
            shown += counter;
            $('.js-hidden-item.js-active').each(function(i) {
                if (count < shown) {
                    if (count == i) {
                        $(this).fadeIn(speed);
                        count++;
                    }
                } else {
                    return false;
                }
            });
            $('.js-active-item-count.js-active').text(counter);

            if (shown >= $('.js-hidden-item.js-active').length) {
                $(this).css('display', 'none');
                $('.js-show-less-items.js-active').css('display', 'block');
            }
            return false;
        });

        $('.js-show-less-items').on('click', function(e) {
            var location = $(this).closest('.js-scroll-to');
            var headerHeight = $('.site-header').outerHeight();

            if (!$(this).hasClass('js-active')) {
                return false;
            }
            e.preventDefault();
            $(this).css('display', 'none');
            shown = 0;
            $('.js-show-more-items.js-active').css('display', 'block');
            $("html, body").animate({
                scrollTop: location.offset().top - headerHeight
            }, "slow");
            $('.js-hidden-item.js-active').css('display', 'none');
            setCounts();
            return false;
        });
    }

    

}

fireNewsroom();